// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import DrrpDataDnaIconOutlinedSvg from "@fishx/icons-svg/es/asn/DrrpDataDnaIconOutlined";
import FishxIcon from '../components/FishxIcon';

var DrrpDataDnaIconOutlined = function DrrpDataDnaIconOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: DrrpDataDnaIconOutlinedSvg
  }));
};

DrrpDataDnaIconOutlined.displayName = 'DrrpDataDnaIconOutlined';
export default React.forwardRef(DrrpDataDnaIconOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/DrrpDataDnaIconOutlined.js
// module id = 2531
// module chunks = 0